module.exports = __webpack_public_path__ + "media/leadPages/footer-img-2-c617e29c.png";